// Events
import { MODAL_CLOSE, MODAL_OPEN } from 'events';
import { component } from 'picoapp';

export default component((node, ctx) => {
  const { products } = node.dataset;
  const productHandles = products.split(',');

  if (products) {
    ctx.on(MODAL_CLOSE, () => {
      node.classList.remove('open');
    });

    ctx.on(MODAL_OPEN, (state, { props }) => {
      if (productHandles.includes(props?.productHandle)) node.classList.add('open');
    });
  }
});
